// extracted by mini-css-extract-plugin
export var box = "_9t-1";
export var checkboxRow = "_9t-8";
export var checked = "_9t-2";
export var descriptionSpacer = "_9t-a";
export var disabled = "_9t-3";
export var icon = "_9t-6";
export var input = "_9t-0";
export var labelSpacer = "_9t-9";
export var medium = "_9t-5";
export var small = "_9t-4";
export var text = "_9t-7";